class PermitMap {
    map!: L.Map;
    markerCluster!: ReturnType<typeof L.markerClusterGroup>;

    $parent: JQuery<HTMLElement>;

    constructor($parent: JQuery<HTMLElement>) {
        this.$parent = $parent;

        this.initialize();
    }

    initialize(): void {

        const mapElement = this.$parent.findInGrid('[name="permitMap"]');

        if (!mapElement.length) {
            return;
        }

        const dataElement = this.$parent.findInGrid('[name="permitMapData"]');

        if (!dataElement.length) {
            return;
        }

        const permits: SepticPermitMapPoint[] = JSON.parse(dataElement.text() || "[]");

        this.createMap(mapElement[0], permits);
    }


    createMap(element: HTMLElement, permits: SepticPermitMapPoint[]): void {
        // If this gets called after a search, destroy old map
        if (this.map) {
            this.map.remove();
        }

        this.map = L.map(element).setView([34.75, -92.28], 7);

        L.tileLayer(
            'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            {
                attribution: '&copy; OpenStreetMap contributors'
            }
        ).addTo(this.map);

        this.markerCluster = L.markerClusterGroup();

        permits.forEach((permit) => {

            if (!permit.Latitude || !permit.Longitude) {
                return;
            }

            const marker = L.marker([
                permit.Latitude,
                permit.Longitude
            ]);


            marker.bindPopup(this.createPopupContent(permit));

            this.markerCluster.addLayer(marker);
        });

        this.map.addLayer(this.markerCluster);

        if (permits.length > 0) {
            const bounds = this.markerCluster.getBounds();

            if (bounds.isValid()) {
                this.map.fitBounds(bounds);
            }
        }
    }

    createPopupContent(permit: SepticPermitMapPoint): string {
        return `
                <div class="row pt-2">
    <div class="col-md-3 fw-bold">
        Receipt#:
    </div>
    <div class="col-md-9 fw-bold">
        ${permit.DocumentNo}
    </div>
</div>
<div class="row pt-2">
    <div class="col-md-3">
        Owner:
    </div>
    <div class="col-md-9">
       ${permit.ValidatedOwner}
    </div>
</div>
<div class="row pt-2">
    <div class="col-md-3">
        Address:
    </div>
    <div class="col-md-9">
       ${permit.PropertyAddress}<br />${permit.City}, ${permit.State} ${permit.Zip}
    </div>
</div>
<div class="row pt-2">
    <div class="col-md-3">
        Subdivision:
    </div>
    <div class="col-md-9">
        ${permit.Subdivision}
    </div>
</div>
<div class="row pt-2">
    <div class="col-md-3">
        Lot No:
    </div>
    <div class="col-md-9">
        ${permit.LotNo}
    </div>
</div>
<div class="row pt-2">
    <div class="col-md-3">
        EHS Specialist:
    </div>
    <div class="col-md-9">
        ${permit.AssignedSanitarianInspector}
    </div>
</div>
<div class="row pt-2">
    <div class="col-md-3">
       Coordinates:
    </div>
    <div class="col-md-9">
        ${permit.Latitude}, ${permit.Longitude}
    </div>
</div>
<div class="row pt-2 row pt-2Group">
    <div class="col-md-12 text-center">
       <a href="/Attachment/ViewFile?modelId=${permit.LastAttachmentId}&amp;propertyName=Data" class="btn btn-primary form-control" ,="" target="_blank" rel="noopener noreferrer" title="${permit.LastAttachmentId}">View PDF</a>
    </div>
</div>
            `;
    }
}

function initializePermitMap($parent: JQuery<HTMLElement>): void {
    new PermitMap($parent);
}